module.exports = __webpack_public_path__ + "static/media/final.1f9d3c27.jpeg";